// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-list {
  overflow: auto;
  padding: 8px 0;
  position: relative;
  outline: none;
}
:where(.vuetify-styles) .v-list {
  border-color: rgba(var(--v-border-color), var(--v-border-opacity));
  border-style: solid;
  border-width: 0;
}
:where(.vuetify-styles) .v-list--border {
  border-width: thin;
  box-shadow: none;
}
:where(.vuetify-styles) .v-list {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-list {
  border-radius: 0;
}
:where(.vuetify-styles) .v-list {
  background: rgba(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-list--disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}
:where(.vuetify-styles) .v-list--nav {
  padding-inline: 8px;
}
:where(.vuetify-styles) .v-list--nav .v-list-item:not(:first-child),
:where(.vuetify-styles) .v-list--nav .v-list-group:not(:first-child) > .v-list-item,
:where(.vuetify-styles) .v-list--nav .v-list-group__items > .v-list-item,
:where(.vuetify-styles) .v-list--nav .v-list-group__items > .v-list-group {
  margin-top: 4px;
}
:where(.vuetify-styles) .v-list--rounded {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-list--subheader {
  padding-top: 0;
}

:where(.vuetify-styles) .v-list-img {
  border-radius: inherit;
  display: flex;
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
}

:where(.vuetify-styles) .v-list-subheader {
  align-items: center;
  background: inherit;
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  display: flex;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  padding-inline-end: 16px;
  min-height: 40px;
  transition: 0.2s min-height cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-list-subheader__text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:where(.vuetify-styles) .v-list--density-default .v-list-subheader {
  min-height: 40px;
  padding-inline-start: calc(16px + var(--indent-padding)) !important;
}

:where(.vuetify-styles) .v-list--density-comfortable .v-list-subheader {
  min-height: 36px;
  padding-inline-start: calc(16px + var(--indent-padding)) !important;
}

:where(.vuetify-styles) .v-list--density-compact .v-list-subheader {
  min-height: 32px;
  padding-inline-start: calc(16px + var(--indent-padding)) !important;
}

:where(.vuetify-styles) .v-list-subheader--inset {
  --indent-padding: 56px;
}
:where(.vuetify-styles) .v-list--nav .v-list-subheader {
  font-size: 0.75rem;
}
:where(.vuetify-styles) .v-list-subheader--sticky {
  background: inherit;
  left: 0;
  position: sticky;
  top: 0;
  z-index: 1;
}

:where(.vuetify-styles) .v-list__overlay {
  background-color: currentColor;
  border-radius: inherit;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 0;
  transition: opacity 0.2s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VList/VList.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kEAAkE;EAClE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sOAAsO;AACxO;AACA;EACE,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,sEAAsE;AACxE;AACA;EACE,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;;;;EAIE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wEAAwE;EACxE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,wDAAwD;AAC1D;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA;EACE,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,OAAO;EACP,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,oCAAoC;AACtC","sourcesContent":[".v-list {\n  overflow: auto;\n  padding: 8px 0;\n  position: relative;\n  outline: none;\n}\n.v-list {\n  border-color: rgba(var(--v-border-color), var(--v-border-opacity));\n  border-style: solid;\n  border-width: 0;\n}\n.v-list--border {\n  border-width: thin;\n  box-shadow: none;\n}\n.v-list {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-list {\n  border-radius: 0;\n}\n.v-list {\n  background: rgba(var(--v-theme-surface));\n  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));\n}\n.v-list--disabled {\n  pointer-events: none;\n  user-select: none;\n}\n.v-list--nav {\n  padding-inline: 8px;\n}\n.v-list--nav .v-list-item:not(:first-child),\n.v-list--nav .v-list-group:not(:first-child) > .v-list-item,\n.v-list--nav .v-list-group__items > .v-list-item,\n.v-list--nav .v-list-group__items > .v-list-group {\n  margin-top: 4px;\n}\n.v-list--rounded {\n  border-radius: 4px;\n}\n.v-list--subheader {\n  padding-top: 0;\n}\n\n.v-list-img {\n  border-radius: inherit;\n  display: flex;\n  height: 100%;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: -1;\n}\n\n.v-list-subheader {\n  align-items: center;\n  background: inherit;\n  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));\n  display: flex;\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.375rem;\n  padding-inline-end: 16px;\n  min-height: 40px;\n  transition: 0.2s min-height cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-list-subheader__text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.v-list--density-default .v-list-subheader {\n  min-height: 40px;\n  padding-inline-start: calc(16px + var(--indent-padding)) !important;\n}\n\n.v-list--density-comfortable .v-list-subheader {\n  min-height: 36px;\n  padding-inline-start: calc(16px + var(--indent-padding)) !important;\n}\n\n.v-list--density-compact .v-list-subheader {\n  min-height: 32px;\n  padding-inline-start: calc(16px + var(--indent-padding)) !important;\n}\n\n.v-list-subheader--inset {\n  --indent-padding: 56px;\n}\n.v-list--nav .v-list-subheader {\n  font-size: 0.75rem;\n}\n.v-list-subheader--sticky {\n  background: inherit;\n  left: 0;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.v-list__overlay {\n  background-color: currentColor;\n  border-radius: inherit;\n  bottom: 0;\n  left: 0;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transition: opacity 0.2s ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
